import { NgClass } from '@angular/common';
import { Component, effect, input, signal } from '@angular/core';

export type AlertType = 'success' | 'danger' | 'info' | 'warning' | 'primary';

export class FormAlert {
  type: AlertType = 'success';
  message: string = '';
}

@Component({
  selector: 'app-alert',
  imports: [NgClass],
  template: `
    @if (_content()) {
      <div
        class="alert alert-dismissible fade show mb-0"
        role="alert"
        [ngClass]="'alert-' + (_content()?.type || 'info')"
      >
        {{ _content()?.message }}

        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="alert"
          aria-label="Close"
          (click)="close()"
        ></button>
      </div>
    }
  `,
  styleUrl: './alert.component.scss',
})
export class AlertComponent {
  content = input<FormAlert | null>(null);

  _content = signal<FormAlert | null>(null);

  constructor() {
    effect(() => {
      this._content.set(this.content());
    });
  }

  close() {
    this._content.set(null);
  }
}
